module.exports = "/v2/pages/dashboard/dist/0c0d4d97bd494de839483f50ef4fe907.svg";